var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function withMountWhenInView(BaseClass, defaultOptions = { threshold: [0, 1] }) {
  var _a, _b;
  return _b = class extends BaseClass {
    constructor(element) {
      super(element);
      __publicField(this, "__isVisible", false);
      __publicField(this, "__observer");
      this.__observer = new IntersectionObserver((entries) => {
        const isVisible = entries.reduce((acc, entry) => acc || entry.isIntersecting, false);
        if (this.__isVisible !== isVisible) {
          this.__isVisible = isVisible;
          if (isVisible) {
            this.$mount();
          } else {
            setTimeout(() => this.$destroy());
          }
        }
      }, { ...defaultOptions, ...this.$options.intersectionObserver });
      this.__observer.observe(this.$el);
      this.$on("terminated", () => {
        this.__observer.disconnect();
      });
    }
    $mount() {
      if (this.__isVisible) {
        super.$mount();
      }
      return this;
    }
  }, __publicField(_b, "config", {
    ...BaseClass.config,
    name: `${BaseClass.config.name}WithMountWhenInView`,
    options: {
      ...((_a = BaseClass.config) == null ? void 0 : _a.options) || {},
      intersectionObserver: Object
    }
  }), _b;
}
export {
  withMountWhenInView as default
};
